/* step indicator YWC — DEV-17279 */
import css_text from '/srv/www/htdocs/loc/app/styles/web_components/step_indicator.css';

function get_shared_sheet() {
	if (get_shared_sheet.cached) {
		return get_shared_sheet.cached;
	}
	const sheet = new CSSStyleSheet();
	sheet.replaceSync(css_text);
	get_shared_sheet.cached = sheet;
	return sheet;
}

class YalwaStepIndicator extends HTMLElement {

	static get observedAttributes() {
		return ['appearance', 'size', 'spacing', 'steps', 'current'];
	}

	constructor() {
		super();
		this.container = null;
		if (!this.shadowRoot) {
			this.attachShadow({mode: 'open'});
		}
		this.apply_css();
		this.handle_click = this.handle_click.bind(this);
	}

	async apply_css() {
		await yalwa.basics.check_stylesheet_polyfill_needed();
		this.shadowRoot.adoptedStyleSheets = [get_shared_sheet()];
	}

	connectedCallback() {
		this.initialize_template();
		this.render();
		this.shadowRoot.addEventListener('click', this.handle_click);
		jQuery(this).removeClass('invisible');
	}

	disconnectedCallback() {
		this.shadowRoot.removeEventListener('click', this.handle_click);
	}

	initialize_template() {
		if (!this.shadowRoot.firstChild) {
			const template = document.createElement('template');
			template.innerHTML = '<div class="step_indicator" part="step_indicator"></div>';
			this.shadowRoot.appendChild(template.content.cloneNode(true));
		}
		this.container = this.shadowRoot.querySelector('.step_indicator');
	}

	attributeChangedCallback(name, old_value, new_value) {
		if (old_value !== new_value && this.container) {
			if (name === 'steps' || name === 'current') {
				this.render();
			} else {
				this.sync_attributes();
			}
		}
	}

	sync_attributes() {
		if (!this.container) {
			return;
		}
		const appearance = this.getAttribute('appearance') || 'default';
		const size = this.getAttribute('size') || 'medium';
		const spacing = this.getAttribute('spacing') || 'medium';
		this.container.setAttribute('data-appearance', appearance);
		this.container.setAttribute('data-size', size);
		this.container.setAttribute('data-spacing', spacing);
	}

	render() {
		if (!this.container) {
			return;
		}
		const total = parseInt(this.getAttribute('steps') || '0', 10);
		if (!total || total < 2) {
			this.container.innerHTML = '';
			return;
		}
		const current = Math.max(1, Math.min(parseInt(this.getAttribute('current') || '1', 10), total));

		this.sync_attributes();

		const dots = [];
		for (let i = 1; i <= total; i++) {
			const is_selected = (i === current);
			const dot = document.createElement('button');
			dot.type = 'button';
			dot.className = 'step_indicator__dot';
			dot.setAttribute('data-selected', is_selected ? 'true' : 'false');
			dot.setAttribute('aria-label', `Step ${i}`);
			if (is_selected) {
				dot.setAttribute('aria-current', 'step');
			}
			dot.dataset.step = String(i);
			dots.push(dot);
		}
		this.container.replaceChildren(...dots);
	}

	handle_click(event) {
		const dot = event.target.closest('.step_indicator__dot');
		if (!dot || !this.container.contains(dot)) {
			return;
		}
		const step = parseInt(dot.dataset.step || '0', 10);
		if (!step) {
			return;
		}
		const current = parseInt(this.getAttribute('current') || '1', 10);
		if (step !== current) {
			this.setAttribute('current', String(step));
		}
		this.dispatchEvent(new CustomEvent('change', {
			detail: { step: step },
			bubbles: true,
			composed: true
		}));
	}
}

customElements.define('yalwa-step-indicator', YalwaStepIndicator);